import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  Text,
  Image,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";

function InvalidCampaignPage() {
  const navigate = useNavigate();

  return (
    <>
      {/* Logo and Branding */}
      <Flex justifyContent="center" alignItems="center" mt={4} mb={4}>
        <Image
          src="../../logoWithTextNoBg.png"
          height={100}
          width={400}
          alt="PurelyGive Logo"
          // boxSize="80px"
        />
      </Flex>

      <Box
        p={6}
        pt={8}
        maxW="600px"
        mx="auto"
        borderWidth={{ base: "0", md: "1px" }}
        mt={4}
        borderRadius={{ base: "0", md: "lg" }}
        boxShadow={{ base: "none", md: "md" }}
      >
        <Alert status="error" mb={4}>
          <AlertIcon />
          Oops! It looks like the donation page link you tried to visit is
          incorrect, missing, or has expired.
        </Alert>

        <Text mb={4}>
          Please check with the nonprofit for the correct link or double-check
          the spelling of the URL. If you&apos;re still having trouble, feel
          free to contact us for assistance.
        </Text>

        <Button
          colorScheme="orange"
          onClick={() => {
            navigate("/");
          }}
        >
          Back to Home
        </Button>
      </Box>

      {/* Footer */}
      <Flex alignItems="center" justifyContent="center" mt={4} mb={6}>
        <Image
          src="../../logoWithTextNoBg.png"
          height={"40px"}
          width={180}
          alt="PurelyGive Logo"
          display="inline"
          // boxSize="20px"
          mr={1}
        />

        <Text fontSize="sm" color="gray.500" ml={4} mr={4}>
          |
        </Text>
        <Text fontSize="sm" color="gray.500">
          <a href="https://PurelyGive.com">Back to our website</a>
        </Text>
        <Text fontSize="sm" color="gray.500" ml={4} mr={4}>
          |
        </Text>
        <Text fontSize="sm" color="gray.500">
          Powered by Stripe
        </Text>
      </Flex>
    </>
  );
}

export default InvalidCampaignPage;
